import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { UserService } from "@services/user.service";

@Injectable()
export class ForgotPasswordInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return forgotPasswordBackend(req.url, req.method, req) || next.handle(req);
    }
}

export function forgotPasswordBackend(url: string, method: string, request: HttpRequest<any>): Observable<HttpEvent<any>> {

    if (url.startsWith(UserService.API_USERS_BASE_PATH) && method === 'PATCH' && request.headers.get('BoschId') === '36122124955843588') {
        return new Observable(resp => {
            resp.next(new HttpResponse<any>({
                status: 200,
                body: {
                    statusCode: 200
                }
            }));
            resp.complete();
        });
    } else {
        return;
    }
}
